import { useEffect, useState } from 'react'

import type { Link } from '@/modules/checkout/_core/domain/entities'
import { isMobileDevice } from '@/modules/checkout/utils/appDeepLink'
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag'
import { FeatureFlag } from '@/shared/libs/launchdarkly/constants'
import { PaymentFlowAnalytics } from '@/shared/utils/analytics'

export const useCanOpenAppCdt = (id: string, link?: Link) => {
  const { isReady, variation, identify } = useFeatureFlag()
  const [isIdentified, setIsIdentified] = useState(false)

  const isEligible =
    Boolean(id) && Boolean(link?.redirectToAppCdt) && isMobileDevice()

  useEffect(() => {
    if (!isReady || !isEligible) {
      return
    }

    let isSubscribed = true

    const release = () => {
      if (isSubscribed) {
        setIsIdentified(true)
      }
    }

    identify({
      linkId: id,
      companyDocument: link?.company.document,
      mainSeller: link?.mainSeller,
    }).then(release, release)

    return () => {
      isSubscribed = false
    }
  }, [
    id,
    identify,
    isEligible,
    isReady,
    link?.company.document,
    link?.mainSeller,
  ])

  const canOpenAppCdt =
    isIdentified && variation(FeatureFlag.RedirectToAppCdt, false)

  useEffect(() => {
    if (!isIdentified) {
      return
    }

    PaymentFlowAnalytics.registerAppCdtFlag(canOpenAppCdt)
  }, [canOpenAppCdt, isIdentified])

  return canOpenAppCdt
}
